import {
    RefreshOutlined } from "../../ui/icons";
import TableRestaurantIcon from "../../ui/icons/TableRestaurant";
import { Grid,
    Tooltip,
    Typography,
    IconButton } from "../../ui";
import React,
    { useState } from "react";
import { useDispatch,
    useSelector } from "react-redux";
import {
  fetchBillDetails,
    fetchBillDetails1,
    fetchBillItems,
    fetchBillPartialPayDetails,
    fetchBillPaymentDetails,
    } from "../../../store/billDetailsSlice";
import DateChangeDialog from "./DateChangeDialog";
import {
  InternalBillType,
  isEmpty
} from "../../../constants/constant";
import uiUtilInstance from "../../../utilities/uiUtil";
import ItemSearchBar from "./ItemSearchBar";
import BillSearchAutocomplete from "../BillSearchAutocomplete";
import AllTableViewDialog from "./AllTableViewDialog";

const NewHeaderForm = () => {
  const [showDateChangeDialog, setShowDateChangeDialog] = useState(false);
  const [showAllTablesDialog, setShowAllTablesDialog] = useState(false);
  const { billDetails } = useSelector((state) => state.bill);
  const dispatch = useDispatch();

  const getBillTypeName = () => {
    let data = "";
    if (billDetails.billType === InternalBillType.Quick) data = "Quick Bill";
    else if (billDetails.billType === InternalBillType.BookTable)
      data = "Table Booking";
    else if (billDetails.billType === InternalBillType.Home)
      data = "Home Delivery";
    else if (billDetails.billType === InternalBillType.TakeAway)
      data = "Take Away";
    if (billDetails.token > -1) {
      data = data + "(Order No: " + billDetails.token + ")";
    }
    return data;
  };

  const handleRefreshBill = () => {
    dispatch(fetchBillDetails1(billDetails.billNo));
    dispatch(fetchBillItems(billDetails.billNo));
    dispatch(fetchBillPartialPayDetails(billDetails.billNo));
    dispatch(fetchBillPaymentDetails(billDetails.billNo));
  };

  return (
    <div className="input-bill-number">
      {/* Search Bar Row: Item search, Bill search, Table icon */}
      <Grid container spacing={0.5} alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={5} sm={5} md={5}>
          <ItemSearchBar />
        </Grid>
        <Grid item xs={5} sm={5} md={5}>
          <BillSearchAutocomplete size="small" />
        </Grid>
        <Grid
          item
          xs={2}
          sm={2}
          md={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Tooltip title="All Tables View">
            <IconButton
              color="primary"
              size="small"
              onClick={() => setShowAllTablesDialog(true)}
              sx={{
                border: "1px solid",
                borderColor: "primary.main",
                borderRadius: 1,
                p: 0.5,
              }}
            >
              <TableRestaurantIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      {/* Existing information row */}
      <Grid
        container
        spacing={0}
        display="flex"
        alignItems="center"
        sx={{ m: 0, p: 0 }}
      >
        <Grid item md={12} xs={12} sm={12}>
          <Typography
            variant="p"
            component="div"
            className="bill-header"
            style={{
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              fontSize: "12px",
            }}
            title={billDetails.createdAt}
            onClick={() => setShowDateChangeDialog(true)}
          >
            Date:{" "}
            {isEmpty(billDetails.createdAt)
              ? uiUtilInstance.getTodayFormattedDate().slice(0, 10)
              : billDetails.createdAt.slice(0, 10)}
          </Typography>
        </Grid>
        <Grid item md={1} xs={1} sm={1}>
          <Tooltip title="Refresh Bill">
            <RefreshOutlined onClick={handleRefreshBill} />
          </Tooltip>
        </Grid>
        <Grid item md={6} xs={11} sm={6}>
          <Typography variant="p" component="div" className="bill-header">
            {getBillTypeName()}
          </Typography>
        </Grid>
        {!isEmpty(billDetails.billNo) && (
          <Grid item md={5} xs={12} sm={6}>
            <Typography variant="p" component="div" className="bill-header">
              Invoice No: {billDetails.billNo}
            </Typography>
          </Grid>
        )}
      </Grid>

      {/* Dialogs */}
      <DateChangeDialog
        showDialog={showDateChangeDialog}
        setShowDialog={setShowDateChangeDialog}
      />
      <AllTableViewDialog
        showDialog={showAllTablesDialog}
        setShowDialog={setShowAllTablesDialog}
      />
    </div>
  );
};

export default NewHeaderForm;
